'use client';

import { Badge } from '@common/components';
import { cn } from '@core/utils';
import { Suspense } from 'react';

import { Image } from '@/components/client';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useAuthStore } from '@/stores/AuthStore';

import { useCoupangEarn } from '../_hooks/useCoupangEarn';

const HERO_IMAGE = {
  alt: '쿠팡',
  src: '/assets/pngs/benefit-coupang/coupang-badge.png',
  width: 240,
  height: 240,
} as const;

//* 가용 여부는 서버 권위(nextAvailableAt)로만 판정한다 — 배지·이미지는 틱이 불필요하고
//* 클라 시각 비교는 하이드레이션 리스크만 더한다. 초 단위 카운트다운은 버튼이 담당.
const CoupangRecommendBadge = () => {
  const { data } = useCoupangEarn();
  const nickName = useAuthStore((state) => state.myInfo?.nickName);

  if (!nickName || data.nextAvailableAtMs !== null) {
    return null;
  }

  return <Badge className="bg-O-25 text-O-600">{nickName}님 맞춤추천</Badge>;
};

const CoupangHeroImage = () => {
  const { data } = useCoupangEarn();

  return (
    <Image
      {...HERO_IMAGE}
      className={cn(data.nextAvailableAtMs !== null && 'opacity-40')}
    />
  );
};

//* 웹에서는 적립 자체가 불가능하다 — 진입하자마자 모달로 가로막는 대신 여기서 먼저 알린다.
//* 앱 판별 전(isChecking)에는 아무것도 그리지 않아 배지가 깜빡이지 않는다.
const StatusBadge = ({ isGuest }: { isGuest: boolean }) => {
  const { isChecking, isWelloApp } = useCheckWelloApp();

  if (isChecking) {
    return null;
  }

  if (!isWelloApp) {
    return <Badge className="bg-O-25 text-O-600">모바일 앱 전용 혜택</Badge>;
  }

  if (isGuest) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <CoupangRecommendBadge />
    </Suspense>
  );
};

interface CoupangEarnStatusProps {
  isGuest: boolean;
}

export const CoupangEarnStatus = ({ isGuest }: CoupangEarnStatusProps) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-32 px-20">
    <div className="flex w-full flex-col items-center gap-12">
      <div className="flex h-24 items-center">
        <StatusBadge isGuest={isGuest} />
      </div>
      <h1 className="text-center font-700 text-Gray-900 typo-h5">
        매일 버튼 누르고
        <br />
        2번 웰포인트 받아요
      </h1>
    </div>
    {isGuest ? (
      <Image {...HERO_IMAGE} />
    ) : (
      <Suspense fallback={<Image {...HERO_IMAGE} className="opacity-40" />}>
        <CoupangHeroImage />
      </Suspense>
    )}
  </div>
);
